// ** Initial State
const initialState = {
    organizations: [],
    resellers: [],
    userOrder: [],
    userPurchase: [],
    userSubscription: [],
    userTestSeries: [],
    userDetails: {},
    allUsers: [],
    pagination: { total: 0, page: 1, pages: 1 }
}

const userReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'GET_ORGANIZATIONS':
            return {
                ...state,
                organizations: action.data
            }
        case 'GET_RESELLERS':
            return {
                ...state,
                resellers: action.data
            }
        case 'GET_USERS':
            return {
                ...state,
                allUsers: action.data,
                pagination: action.pagination || state.pagination
            }
        case 'SET_PURCHASE_DETAILS':
            return {
                ...state,
                userOrder: action.data.userOrder,
                userPurchase: action.data.userPurchase,
                userSubscription: action.data.userSubscription,
                userTestSeries: action.data.userTestSeries,
                userDetails: action.data.userDetails
            }
        default:
            return state
    }
}

export default userReducer
